<div class="main-content mb-4 mx-lg-4 mx-md-4 mx-sm-0 px-sm-4 px-3">
    <ms-page-title />

    <div class="page-title-wrapper">
        <div class="d-flex justify-content-between flex-row flex-wrap gap-3">
            <div>
                <!-- Search Input Group -->
                <div class="input-group position-relative">
                    <input id="search" type="text" class="form-control form-control-solid ps-13 pe-5"
                        placeholder="Search Emails" aria-label="Search Emails"
                        [ngModel]="userSessionService.sentEmailsFilter.searchTerm"
                        (ngModelChange)="userSessionService.sentEmailsFilter.searchTerm = $event"
                        (keyup.enter)="onFilterApplied()" aria-describedby="search-description">

                    @if (userSessionService.sentEmailsFilter.searchTerm) {
                    <button
                        class="btn btn-link position-absolute top-50 translate-middle-y p-0 border-0 bg-transparent mx-2 input-group-clear-button"
                        type="button" (click)="clearSearch()" aria-label="Clear search">
                        <fa-duotone-icon icon="xmark" class="text-secondary fs-6" secondaryOpacity="0.9" size="lg" />
                    </button>
                    }

                    <div class="input-group-append">
                        <button class="btn btn-primary rounded-0 rounded-end" type="button" (click)="onFilterApplied()"
                            id="button-addon2">
                            Search
                        </button>
                    </div>
                </div>
                <!-- Search Input Group -->
                <div id="search-description" class="ps-2 mt-2 text-muted small fst-italic">
                    Search by recipient email address or subject
                </div>
            </div>

            <div class="d-flex gap-3">
                <ms-sent-email-search-filter
                    [filter]="userSessionService.sentEmailsFilter"
                    (filterApplied)="onFilterApplied()" />

                <ms-sort-dropdown
                    [sortOptions]="sortOptions"
                    [selectedSortOption]="orderBy()"
                    (selectedSortOptionChange)="onSortChanged($event)" />
            </div>
        </div>
    </div>

    <ms-sent-email-list-table
        #sentEmailTable
        class="d-block mt-4"
        [filter]="userSessionService.sentEmailsFilter"
        [orderByInput]="orderBy()"
        (orderByChanged)="onListOrderByChanged($event)" />
</div>
